import { h, t, T, domWithScope } from '@jsx6/jsx6'
import { ChatBox } from '../ChatBox.js'
/**
 * 
 * @param {Element} logo 
 * @param {ChatBox} chat 
 * @returns Element
 */
export const areaForm = (chat) => {
  const hasNameInfo = !t('info_name') || t('info_name') !== 'info_name'
  const hasEmailInfo = !t('info_email') || t('info_email') !== 'info_email'
  const hasTelephoneInfo = !t('info_telephone') || t('info_telephone') !== 'info_telephone'

  return (
    <div p="area.form" class="chatForm" hidden>
      <div p='loading' hidden>
        <div class="loading-area"><div></div><div></div></div>
      </div>
      <div class="chatHeading">
        <div class="heading-content" p="formWelcomeMessage"></div>
        <div class="chatTopbar">
          <span p="bt.minimize" onclick={e => chat.minimize('areaForm')} icon="x-mark" />
        </div>
      </div>
      <div p="welcomeMsg" class="welcome" selector="--heading-color"></div>
      <div class="instruction" selector="--subheading-color">{T`enter_data`}</div>
      <div p="formVideoDialog"></div>

      <div class="form-wrapper">
        <div class="form-line">
          <label class="label-actions">
            {T`name`}
            <div class="tooltip" hidden={!hasNameInfo}>
              <span class="btn-icon" icon="info"></span>
              <div class="tooltip-text">{T`info_name`}</div>
            </div>
          </label>
          <input p="items.name" placeholder={T`placeholder_name`} />
          <div p="errorName" class="error-message" hidden>
            {T`required_message`}
          </div>
        </div>
        <div class="form-line">
          <label class="label-actions">
            {T`email`}
            <div class="tooltip" hidden={!hasEmailInfo}>
              <span class="btn-icon" icon="info"></span>
              <div class="tooltip-text">{T`info_email`}</div>
            </div>
          </label>
          <input p="items.email" placeholder={T`placeholder_email`} />
          <div p="errorEmail" class="error-message" hidden>
            {T`required_message`}
          </div>
          <div p="errorEmailFilter" class="error-message" hidden>
            {T`incorrect_email_format`}
          </div>
        </div>
        <div class="form-line">
          <label class="label-actions">
            <span>{T`telephone`}</span>
            <div class="tooltip" hidden={!hasTelephoneInfo}>
              <span class="btn-icon" icon="info"></span>
              <div class="tooltip-text">{T`info_telephone`}</div>
            </div>
          </label>
          <input p="items.tel" placeholder={T`placeholder_telephone`} />
          <div p="errorTel" class="error-message" hidden>
            {T`required_message`}
          </div>
        </div>
        <div class="form-line">
          <label p="topicLabel">{T`topic`}</label>
          <input p="topic" />
          <label p="topicNlbLabel">{T`topic_nlb`}</label>
          <select p="topicNLB" hidden required>
          </select>
          <div p="errorTopic" class="error-message" hidden>
            {T`required_message`}
          </div>
        </div>

        <div class="form-inline" p="termsWrapper" hidden>
          <label class="label-terms">
            <input p="items.terms" type="checkbox" />
            <span>
              {T`agree_with`}
              {` `}
              <a href="" p="termsUrl" target="_blank">
                {T`general_terms`}
              </a>
              <span p="gdprWrapper" class="gdpr-wrapper" hidden>
                {T`gdpr_text`}
                <a href="" p="gdprUrl" target="_blank">
                  {T`gdpr_link_text`}
                </a>
              </span>
            </span>
          </label>
          <div p="errorTerms" class="error-message" hidden>
            {T`required_message`}
          </div>
        </div>
      </div>

      <div class="form-line buttons-line">
        <button p="bt.start" class="btn btn-primary" onclick={e => chat.startAfterForm(true)} selector="--button-bg,--button-txt">
          {T`start_chat`}
        </button>
      </div>
      <div class="chatFooter">
        {chat.$s.logo}
        <div></div>
      </div>
    </div>
  )
}
